import Link from "next/link";
import { cx } from "@nju/css";
import { pushMenuCLickEvent } from "@nju/data-layer";
import { Icon } from "@nju/icons";
import { A, Badge, Text } from "@nju/ui";
import { IHeaderMenuItemProps } from "../types";

interface IHeaderMenuDesktopActiveItemComponentProps {
  isLast: boolean;
  isFirst: boolean;
  oddItem: boolean;
}

export function HeaderMenuDesktopActiveItem({
  icon,
  additionalIcon,
  links,
  title,
  isLast,
  isFirst,
  oddItem,
}: IHeaderMenuItemProps & IHeaderMenuDesktopActiveItemComponentProps) {
  const has2Rows = links.length > 4;

  const mapLinks = links?.map((itemLink, indexLink) => {
    return (
      <div
        className="min-h-[27px] flex flex-row gap-1 pl-[39px]"
        key={`headerItemLink_${indexLink}`}
      >
        {(itemLink?.icon || itemLink?.additionalIcon) && (
          <div className="mr-2 flex items-center">
            {itemLink?.icon && (
              <Icon height={24} name={itemLink.icon} tone="accent" width={24} />
            )}
            {itemLink?.additionalIcon && (
              <div className="flex gap-[2px] items-center">
                <Text size="l" tone="accent">
                  +
                </Text>
                <Icon
                  height={24}
                  name={itemLink.additionalIcon}
                  tone="accent"
                  width={24}
                />
              </div>
            )}
          </div>
        )}
        <Link
          className="hover:underline"
          href={itemLink.href}
          id={`menu_nm_${title}_${itemLink.title}`}
          onClick={() => {
            return pushMenuCLickEvent({
              id: `menu_nm_${title}_${itemLink.title}`,
            });
          }}
          passHref={true}
        >
          <A size="inline" variant="neutral">
            <Text size="l" tone="neutral">
              {itemLink.title}
            </Text>
          </A>
        </Link>
        {itemLink.badge && (
          <Badge
            badgeText={itemLink.badge?.title}
            fontSize={14}
            small={true}
            variant={itemLink.badge.tone === "accent" ? "cerulean" : "yellow"}
          />
        )}
      </div>
    );
  });

  return (
    <div
      className={cx("max-h-[214px] bg-white flex flex-col gap-4 pb-6", {
        "border-r-1 border-geyser pl-5": !isFirst,
        "border-r-1 border-geyser pl-5 from-desktop:pl-0 pr-5": isFirst,
        "only-tablet:border-none": oddItem || has2Rows || isLast,
        "border-none": isLast,
        "from-desktop:pl-5": !isFirst,
        "w-1/2 from-desktop:w-1/4": !has2Rows,
        "w-full from-desktop:w-1/2": has2Rows,
      })}
    >
      <div className="h-[26px]">
        <div className="flex gap-3 items-center justify-start">
          {(icon || additionalIcon) && (
            <div className="flex gap-1 items-center">
              {icon && (
                <Icon
                  data-cy="agent-menu-button"
                  height={24}
                  name={icon}
                  tone="accent"
                  width={24}
                />
              )}
              {additionalIcon && (
                <div className="flex gap-1 items-center">
                  <Text size="l" tone="accent">
                    +
                  </Text>
                  <Icon
                    height={24}
                    name={additionalIcon}
                    tone="accent"
                    width={24}
                  />
                </div>
              )}
            </div>
          )}
          <Text size="l" tone="accent">
            {title}
          </Text>
        </div>
      </div>
      <div className="flex flex-col gap-4 flex-wrap h-full">{mapLinks}</div>
    </div>
  );
}
